define("powergen/transforms/size",
  [],
  function() {
    "use strict";
    var SizeTransform;

    SizeTransform = DS.Transform.extend({
      serialize: function(value) {
        return {
          width: value.get('width'),
          height: value.get('height')
        };
      },
      deserialize: function(value) {
        return this.get('store').createRecord('size', {
          width: value.width,
          height: value.height
        });
      }
    });


    return SizeTransform;
  });